<!-- 移动端首页 -->
<template>
  <div class="mIndex">
    <mb-header active="true"></mb-header>

    <div class="khk_part_1" :style="{ height: getClientHeight + 'px' }">
      <div class="khk_logo_img">
        <img src="../assets/m/ml-logo.png" alt class="khk_logo_img_1" />
        <img
          src="../assets/m/ml-txt1.png"
          alt
          class="animated pulse khk_logo_img_2"
        />
        <img
          src="../assets/m/ml-txt2.png"
          alt
          :class="['scrollin', { khk_logo_img_3: scrollin }]"
        />
      </div>
      <swiper
        class="swiper-container-one"
        id="home"
        :allow-touch-move="false"
        :options="swiperOption"
        :style="{ height: getClientHeight + 'px' }"
      >
        <!-- slides -->
        <swiper-slide
          class="swiper-item"
          v-for="item of swiperList"
          :key="item.id"
        >
          <!-- <swiper-slide class="swiper-item"> -->
          <img class="swiper-img" :src="item.imgUrl" alt />
        </swiper-slide>
      </swiper>

      <div class="search">
        <input
          placeholder="输入型号搜索"
          v-model="searchValue"
          @keyup.enter="onhandleShowModal"
        />
        <img
          src="../assets/m/search.png"
          alt
          @click="onhandleShowModal"
          class="key"
        />
      </div>
    </div>
    <div
      class="khk_part_2"
      :style="{ height: getClientHeight + 'px' }"
      id="introduction"
    >
      <div class="khk_part_2_content">
        <div class="text_wrapper">
          <img src="../assets/m/H2/文字.png" />
        </div>
        <div class="group_wrapper">
          <img src="../assets/m/H2/KHKGROUP.png" />
        </div>
      </div>

      <!-- <div
        class="content"
        :style="{ fontSize: 12 +'px'}"
        v-html="introductionContentInfo && introductionContentInfo.copy_writing_content"
      ></div> -->
    </div>
    <div
      class="khk_part_2_B"
      :style="{ height: getClientHeight + 'px' }"
      id="origin"
    >
      <div class="khk_part_2_img">
        <img src="../assets/m/khk002b-2.png" alt />
      </div>
      <div class="office">
        <swiper
          class="swiper-container-two"
          id="home1"
          :options="swiperOptionTwo"
        >
          <!-- slides -->
          <swiper-slide
            class="swiper-item"
            v-for="(item, index) of imgList1"
            :key="index"
          >
            <!-- <swiper-slide class="swiper-item"> -->
            <img class="swiper-img" :src="item" alt />
          </swiper-slide>
        </swiper>
      </div>
    </div>
    <div
      class="khk_part_3"
      :style="{ height: getClientHeight + 'px' }"
      id="products"
    >
      <ul class="box_ul">
        <li>
          <router-link to="/m_products/1" class="prod prod1">
            <img src="../assets/m/cp1.png" alt class="prc_img" />
          </router-link>
        </li>
        <li>
          <router-link to="/m_products/8" class="prod prod1">
            <img src="../assets/m/cp2.png" alt class="prc_img" />
          </router-link>
        </li>
        <li>
          <router-link to="/m_products/9" class="prod prod1">
            <img src="../assets/m/cp3.png" alt class="prc_img active" />
          </router-link>
        </li>
        <li>
          <router-link to="/m_products/10" class="prod prod1">
            <img src="../assets/m/cp4.png" alt class="prc_img" />
          </router-link>
        </li>
        <li>
          <router-link to="/m_products/11" class="prod prod1">
            <img src="../assets/m/cp5.png" alt class="prc_img" />
          </router-link>
        </li>
        <li>
          <router-link to="/m_products/13" class="prod prod1">
            <img src="../assets/m/cp6.png" alt class="prc_img" />
          </router-link>
        </li>
      </ul>
      <div class="khk_part_3_content">
        <div class="text_wrapper">
          <p>小原齿轮</p>
          <p>日本独立齿轮制造商，专业制造标准齿轮种类多达</p>
          <p>300 个系列，3 万种规格。</p>
          <p>正齿轮，锥齿轮，斜齿齿轮，交错轴齿轮，</p>
          <p>蜗轮蜗杆，齿轮箱，减速机齿轮，</p>
          <p>标准品常备库存，交期短，订货没有起订量限制!</p>
        </div>
      </div>
    </div>
    <div
      class="khk_part_4"
      :style="{ height: getClientHeight + 'px' }"
      id="techCenter"
    >
      <ul class="box_ul">
        <li>
          <router-link to="/m_tech/1" class="tech">
            <img src="../assets/m/4-1.png" alt class="prc_img" />
          </router-link>
        </li>
        <li>
          <router-link to="/m_tech/2" class="tech">
            <img src="../assets/m/4-2.png" alt class="prc_img" />
          </router-link>
        </li>
        <li>
          <router-link to="/m_tech/3" class="tech">
            <img src="../assets/m/4-3.png" alt class="prc_img active" />
          </router-link>
        </li>
        <li>
          <router-link to="/m_tech/4" class="tech">
            <img src="../assets/m/4-4.png" alt class="prc_img" />
          </router-link>
        </li>
      </ul>
      <div class="tech-center">
        <img src="../assets/new_btn_2.png" alt="技术中心" />
        <!-- <div class="h1-zh">技术中心</div>
        <div class="h1-en">Tech Center</div>
        <div class="h2">设计常见问题</div> -->
      </div>
    </div>
    <div
      class="khk_part_5"
      :style="{ height: getClientHeight + 'px' }"
      id="importExport"
    >
      <!-- <img class="img" src="../assets/m/h5.png" alt /> -->
      <div class="khk_part_5_btn_wrapper">
        <div class="link_btn_area">
          <a href="https://sh-million.com/m_products/1">
            <img class="img_btn img_left" src="../assets/m/左按钮.gif" />
          </a>
          <a href="https://sh-million.com/m_tech/2">
            <img class="img_btn img_right" src="../assets/m/右按钮.gif" />
          </a>
        </div>

        <!-- <div class="call_btn">
          <a href="tel:18001827959">
            <img class="call_btn_img" src="../assets/m/电话按钮.png" />
          </a>
        </div> -->
      </div>
      <!-- <div class="khk_part_5_content">
        <img src="../assets/m/H5/流程图.png" />
        <img src="../assets/m/H5/仅一天.png">
      </div> -->
    </div>
    <div
      class="khk_part_6"
      :style="{ height: getClientHeight + 'px' }"
      id="partner"
    >
      <swiper
        class="swiper-container-three"
        id="home2"
        :options="swiperOptionThree"
      >
        <!-- slides -->
        <swiper-slide
          class="swiper-item"
          v-for="(item, index) of imgList2"
          :key="index"
        >
          <!-- <swiper-slide class="swiper-item"> -->
          <img class="swiper-img" :src="item" alt />
        </swiper-slide>
      </swiper>
      <div class="khk_info">
        <p>
          小原齿轮（KHK齿轮）自创业以来经历了80余年，一直专注于齿轮制造。
          KHK凭借训练有素的员工、先进的生产设备、长年积累的生产诀窍及不断的改善活动，使KHK小原齿轮工业建立起了一整套能够满足当今世界不同客户需求的完整生产体系。
        </p>
        <p>
          KHK标准齿轮多达3万种，在销售方面，小原齿轮工业通过专业的代理店在世界各地提供区域性服务，通过KHK广泛的销售网络，将价格合理的小原齿轮产品安全迅速地送到客户手中。
        </p>
        <p>
          “提供信赖和满足” 是KHK小原齿轮工业的座右铭。
          小原齿轮全体员工将一如既往齐心协力，为能提供满足客户需求的产品不断努力。
        </p>
      </div>
      <router-link to="/m_partner" class="btn">了解更多</router-link>
    </div>
    <div
      class="khk_part_7"
      :style="{ height: getClientHeight + 'px' }"
      id="aboutUs"
    >
      <div class="about">
        <router-link to="/m_advantage" class="pantner">
          <img src="../assets/mail-a.png" class="img_1" />
        </router-link>
        <router-link to="/m_contentUS" class="content">
          <img src="../assets/mail-b.png" class="img_2" />
        </router-link>
      </div>
      <ul class="body_content">
        <li>
          <img src="../assets/m/blo.png" alt />
        </li>
        <li>
          <img src="../assets/m/blo1.png" alt />
        </li>
        <li>
          <img src="../assets/m/blo2.png" alt />
        </li>
        <li>
          <img src="../assets/m/blo4.png" alt />
        </li>
        <li @click="openModal">
          <img src="../assets/m/blo3.png" alt />
        </li>
      </ul>
      <div class="web-menu">
        <div class="web-menu-item" v-for="(goup_item, i) of menuData" :key="i">
          <div class="web-menu-first">{{ goup_item.menu_group_name }}</div>
          <div class="web-menu-sub-item">
            <div
              class="web-menu-sub"
              v-for="(sub_item, ik) of goup_item.sub_menu"
              :key="ik"
            >
              <a :href="sub_item.menu_link"> {{ sub_item.menu_name }} </a>
            </div>
          </div>
        </div>
        <!-- <div class="web-menu-item">
            <div class="web-menu-first">战略合作伙伴</div>
            <div class="web-menu-sub-item">
              <div class="web-menu-sub">
                <a href="">川口工厂</a>
              </div>
              <div class="web-menu-sub"><a href="">野田工厂</a></div>
              <div class="web-menu-sub"><a href="">野田第二工厂</a></div>
            </div>
          </div>

          <div class="web-menu-item">
            <div class="web-menu-first">关于齿轮</div>
            <div class="web-menu-sub-item">
              <div class="web-menu-sub"><a href="">侧隙问题</a></div>
              <div class="web-menu-sub"><a href="">强度问题</a></div>
              <div class="web-menu-sub"><a href="">齿轮应用</a></div>
            </div>
          </div>

          <div class="web-menu-item">
            <div class="web-menu-first">产品中心</div>
            <div class="web-menu-sub-item">
              <div class="web-menu-sub"><a href="">KHK 齿轮</a></div>
              <div class="web-menu-sub"><a href="">KHK 齿条</a></div>
              <div class="web-menu-sub"><a href="">涡轮蜗杆</a></div>
              <div class="web-menu-sub"><a href="">其他产品</a></div>
            </div>
          </div>

          <div class="web-menu-item">
            <div class="web-menu-first">服务与支持</div>
            <div class="web-menu-sub-item">
              <div class="web-menu-sub"><a href="">3D 图纸下载</a></div>
              <div class="web-menu-sub"><a href="">计算公式</a></div>
              <div class="web-menu-sub"><a href="">样册索取</a></div>
            </div>
          </div>

          <div class="web-menu-item">
            <div class="web-menu-first">服务与支持</div>
            <div class="web-menu-sub-item">
              <div class="web-menu-sub"><a href="">3D 图纸下载</a></div>
              <div class="web-menu-sub"><a href="">计算公式</a></div>
              <div class="web-menu-sub"><a href="">样册索取</a></div>
            </div>
          </div> -->
      </div>
    </div>
    <mb-fotter></mb-fotter>
    <back-top></back-top>
    <div class="modal-backdrop" v-show="showModal" @click="closeModal">
      <div class="modal" id="modal">
        <div class="modal-close" @click="closeModalCuspor">X</div>

        <div class="modal-header">{{ titleText || "提示" }}</div>
        <div class="modal-body">
          <img :src="textImageInfo.show_image_address" alt />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper } from "vue-awesome-swiper";
import request from "../server/request.js";
import mbFotter from "../components/moblie-fotter.vue";
import mbHeader from "../components/moblie-header.vue";
import backTop from "../components/back-top.vue";
import { setTimeout } from "timers";

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    mbFotter,
    mbHeader,
    backTop,
  },

  data() {
    //这里存放数据
    return {
      showModal: false,
      matrixProdsHeight: 30,
      matrixProdsOpacity: 0,
      textImageInfo: {},
      titleText: "",
      getClientHeight:
        document.documentElement.clientHeight || document.body.clientHeight,
      swiperOption: {
        allowTouchMove: false,
        touchStartPreventDefault: false,
        autoplay: true,
        speed: 1800,
        delay: 2000,
        loop: true,
        effect: "fade",
        obvserver: true,
        obvserverParents: true,
        fadeEffect: {
          crossFade: true,
        },
      },
      menuData: [
        {
          id: 1,
          c_addition_date: "2022-06-22T06:29:21.000Z",
          c_addition_unix: 1655908161,
          c_is_delete: false,
          guid: "b50fa3f2-f237-11ec-bb0d-0242ac110003",
          menu_type: "1",
          menu_index: "100",
          menu_group_key: "A100",
          menu_group_name: "战略合作伙伴",
          menu_name: "战略合作伙伴",
          menu_link: "https://baidu.com",
          sub_menu: [
            {
              id: 8,
              c_addition_date: "2022-06-22T06:57:38.000Z",
              c_addition_unix: 1655909858,
              c_is_delete: false,
              guid: "a873bd3b-f23b-11ec-bb0d-0242ac110003",
              menu_type: "2",
              menu_index: "103",
              menu_group_key: "A100",
              menu_group_name: "战略合作伙伴",
              menu_name: "野田第二工厂",
              menu_link: "https://baidu.com",
            },
            {
              id: 7,
              c_addition_date: "2022-06-22T06:57:09.000Z",
              c_addition_unix: 1655909829,
              c_is_delete: false,
              guid: "971d8f0b-f23b-11ec-bb0d-0242ac110003",
              menu_type: "2",
              menu_index: "102",
              menu_group_key: "A100",
              menu_group_name: "战略合作伙伴",
              menu_name: "野田工厂",
              menu_link: "https://baidu.com",
            },
            {
              id: 6,
              c_addition_date: "2022-06-22T06:56:40.000Z",
              c_addition_unix: 1655909800,
              c_is_delete: false,
              guid: "85d2360e-f23b-11ec-bb0d-0242ac110003",
              menu_type: "2",
              menu_index: "101",
              menu_group_key: "A100",
              menu_group_name: "战略合作伙伴",
              menu_name: "川口工厂",
              menu_link: "https://baidu.com",
            },
            {
              id: 23,
              c_addition_date: "2022-06-26T03:35:34.000Z",
              c_addition_unix: 1656243334,
              c_is_delete: false,
              guid: "17b8d21e-f544-11ec-bb0d-0242ac110003",
              menu_type: "2",
              menu_index: "1",
              menu_group_key: "A100",
              menu_group_name: "战略合作伙伴",
              menu_name: "1",
              menu_link: "1",
            },
          ],
        },
        {
          id: 2,
          c_addition_date: "2022-06-22T06:29:54.000Z",
          c_addition_unix: 1655908194,
          c_is_delete: false,
          guid: "c89ae08a-f237-11ec-bb0d-0242ac110003",
          menu_type: "1",
          menu_index: "200",
          menu_group_key: "A200",
          menu_group_name: "关于齿轮",
          menu_name: "关于齿轮",
          menu_link: "https://baidu.com",
          sub_menu: [
            {
              id: 11,
              c_addition_date: "2022-06-22T06:59:17.000Z",
              c_addition_unix: 1655909957,
              c_is_delete: false,
              guid: "e37e1087-f23b-11ec-bb0d-0242ac110003",
              menu_type: "2",
              menu_index: "203",
              menu_group_key: "A200",
              menu_group_name: "关于齿轮",
              menu_name: "齿轮应用",
              menu_link: "https://baidu.com",
            },
            {
              id: 10,
              c_addition_date: "2022-06-22T06:58:41.000Z",
              c_addition_unix: 1655909921,
              c_is_delete: false,
              guid: "ce0a44a3-f23b-11ec-bb0d-0242ac110003",
              menu_type: "2",
              menu_index: "202",
              menu_group_key: "A200",
              menu_group_name: "关于齿轮",
              menu_name: "强度问题",
              menu_link: "https://baidu.com",
            },
            {
              id: 9,
              c_addition_date: "2022-06-22T06:58:11.000Z",
              c_addition_unix: 1655909891,
              c_is_delete: false,
              guid: "bbed06fd-f23b-11ec-bb0d-0242ac110003",
              menu_type: "2",
              menu_index: "201",
              menu_group_key: "A200",
              menu_group_name: "关于齿轮",
              menu_name: "侧隙问题",
              menu_link: "https://baidu.com",
            },
          ],
        },
        {
          id: 3,
          c_addition_date: "2022-06-22T06:31:47.000Z",
          c_addition_unix: 1655908307,
          c_is_delete: false,
          guid: "0c137a7f-f238-11ec-bb0d-0242ac110003",
          menu_type: "1",
          menu_index: "300",
          menu_group_key: "A300",
          menu_group_name: "产品中心",
          menu_name: "产品中心",
          menu_link: "https://baidu.com",
          sub_menu: [
            {
              id: 15,
              c_addition_date: "2022-06-22T07:01:25.000Z",
              c_addition_unix: 1655910085,
              c_is_delete: false,
              guid: "2fd37d82-f23c-11ec-bb0d-0242ac110003",
              menu_type: "2",
              menu_index: "304",
              menu_group_key: "A300",
              menu_group_name: "产品中心",
              menu_name: "其他产品",
              menu_link: "https://baidu.com",
            },
            {
              id: 14,
              c_addition_date: "2022-06-22T07:00:48.000Z",
              c_addition_unix: 1655910048,
              c_is_delete: false,
              guid: "19e1fba6-f23c-11ec-bb0d-0242ac110003",
              menu_type: "2",
              menu_index: "303",
              menu_group_key: "A300",
              menu_group_name: "产品中心",
              menu_name: "涡轮蜗杆",
              menu_link: "https://baidu.com",
            },
            {
              id: 13,
              c_addition_date: "2022-06-22T07:00:16.000Z",
              c_addition_unix: 1655910016,
              c_is_delete: false,
              guid: "06e53a71-f23c-11ec-bb0d-0242ac110003",
              menu_type: "2",
              menu_index: "302",
              menu_group_key: "A300",
              menu_group_name: "产品中心",
              menu_name: "KHK 齿条",
              menu_link: "https://baidu.com",
            },
            {
              id: 12,
              c_addition_date: "2022-06-22T07:00:03.000Z",
              c_addition_unix: 1655910003,
              c_is_delete: false,
              guid: "ff0f6529-f23b-11ec-bb0d-0242ac110003",
              menu_type: "2",
              menu_index: "301",
              menu_group_key: "A300",
              menu_group_name: "产品中心",
              menu_name: "KHK 齿轮",
              menu_link: "https://baidu.com",
            },
          ],
        },
        {
          id: 4,
          c_addition_date: "2022-06-22T06:32:24.000Z",
          c_addition_unix: 1655908344,
          c_is_delete: false,
          guid: "22459d5b-f238-11ec-bb0d-0242ac110003",
          menu_type: "1",
          menu_index: "400",
          menu_group_key: "A400",
          menu_group_name: "服务与支持",
          menu_name: "服务与支持",
          menu_link: "https://baidu.com",
          sub_menu: [
            {
              id: 18,
              c_addition_date: "2022-06-22T07:06:24.000Z",
              c_addition_unix: 1655910384,
              c_is_delete: false,
              guid: "e1b034ca-f23c-11ec-bb0d-0242ac110003",
              menu_type: "2",
              menu_index: "403",
              menu_group_key: "A400",
              menu_group_name: "服务与支持",
              menu_name: "样册索取",
              menu_link: "https://baidu.com",
            },
            {
              id: 17,
              c_addition_date: "2022-06-22T07:04:45.000Z",
              c_addition_unix: 1655910285,
              c_is_delete: false,
              guid: "a6b2618d-f23c-11ec-bb0d-0242ac110003",
              menu_type: "2",
              menu_index: "402",
              menu_group_key: "A400",
              menu_group_name: "服务与支持",
              menu_name: "计算公式",
              menu_link: "https://baidu.com",
            },
            {
              id: 16,
              c_addition_date: "2022-06-22T07:03:51.000Z",
              c_addition_unix: 1655910231,
              c_is_delete: false,
              guid: "86f3a401-f23c-11ec-bb0d-0242ac110003",
              menu_type: "2",
              menu_index: "401",
              menu_group_key: "A400",
              menu_group_name: "服务与支持",
              menu_name: "3D 图纸下载",
              menu_link: "https://baidu.com",
            },
          ],
        },
      ],
      swiperOptionTwo: {
        mousewheel: false,
        autoplay: true,
        speed: 1800,
        delay: 2000,
        loop: true,
        effect: "coverflowEffect",
        // effect: "fade",
        slidesPerView: 2,
        // centeredSlides: true,
        coverflowEffect: {
          rotate: 30,
          stretch: 10,
          depth: 60,
          modifier: 2,
          slideShadows: true,
        },
      },
      swiperOptionThree: {
        autoplay: true,
        speed: 1800,
        delay: 2000,
        loop: true,
        effect: "fade",
        obvserver: true,
        obvserverParents: true,
        fadeEffect: {
          crossFade: true,
        },
      },
      searchValue: "",
      scrollin: false,
      swiperList: [
        {
          id: 2,
          imgUrl: require("../assets/m/m-H1A.png"),
        },
        {
          id: 3,
          imgUrl: require("../assets/m/m-H1B.png"),
        },
        {
          id: 1,
          imgUrl: require("../assets/m/m-H1C.png"),
        },
      ],
      imgList1: [
        require("../assets/m/office/006.jpg"),
        require("../assets/m/office/007.jpg"),
        require("../assets/m/office/008.jpg"),
        require("../assets/m/office/009.jpg"),
        require("../assets/m/office/010.jpg"),
        require("../assets/m/office/011.jpg"),
        require("../assets/m/office/012.jpg"),
        require("../assets/m/office/013.jpg"),
        require("../assets/m/office/014.jpg"),
        require("../assets/m/office/015.jpg"),
        require("../assets/m/office/016.jpg"),
        require("../assets/m/office/017.jpg"),
      ],
      imgList2: [
        require("../assets/m/H6BAN1.jpg"),
        require("../assets/m/H6BAN2.jpg"),
        require("../assets/m/H6BAN3.jpg"),
      ],
      // introductionContentInfo: {
      //   copy_writing_title: "",
      //   copy_writing_content: ""
      // }
    };
  },

  //监听属性 类似于data概念
  computed: {},

  //监控data中的数据变化
  watch: {
    getClientHeight: function () {
      window.onresize(() => {
        this.getClientHeight =
          document.documentElement.clientHeight || document.body.clientHeight;
      });
    },
  },

  //方法集合
  methods: {
    closeModalCuspor() {
      this.showModal = false;
    },
    closeModal() {
      const dom = document.getElementById("modal");
      if (dom) {
        if (!dom.contains(event.target)) {
          this.showModal = false;
        }
      }
    },
    openModal() {
      this.showModal = true;
      this.titleText = "KHK授权代理证";
    },
    initSwiper() {
      setTimeout(() => {
        new Swiper(".swiper-container-one", {
          autoplay: true,
          speed: 1800,
          delay: 2000,
          loop: true,
          effect: "fade",
          obvserver: true,
          obvserverParents: true,
          fadeEffect: {
            crossFade: true,
          },
          observer: true, // 启动动态检查器(OB/观众/观看者)
          observeParents: true, // 修改swiper的父元素时，自动初始化swiper
        });
      }, 300);
    },
    getShowImage() {
      this.$nextTick(() => {
        this.initSwiper();
      });
    },
    onhandleShowModal() {
      if (!this.searchValue) {
        alert("请输入搜索内容");
      } else {
        window.open(
          "https://www.khkgears.co.jp/khkweb/zout/FFcreateWK.do?catalogno=" +
            this.searchValue +
            "&lang=zh_CN"
        );
      }
    },
    loadData() {
      request.getShowImage((res) => {
        this.textImageInfo = res.data.filter(
          (item) => item.show_image_location == "khk007a"
        )[0];
      });
      request.getWebMenu((res) => {
        if (res && res.length > 0) {
          const _menuData = res;
          const groupData = _menuData
            .filter((k) => k.menu_type == "1")
            .sort((a, b) => a.menu_index - b.menu_index);
          let groupDataObj = {};
          groupData.forEach((item) => {
            groupDataObj[item.menu_group_name] = item;
            groupDataObj[item.menu_group_name]["sub_menu"] = _menuData
              .filter(
                (k) =>
                  k.menu_type == "2" && k.menu_group_key == item.menu_group_key
              )
              .sort((a, b) => b.menu_index - a.menu_index);
          });
          this.menuData = Object.values(groupDataObj);
          // console.log(Object.values(groupDataObj));
          // this.menuuData = Object.values();
          // this.menuData = res.data;
        }
      });
      // request.getIntroductionContent(res => {
      //   if (res && res.data.length > 0) {
      //     this.introductionContentInfo = res.data[0];
      //     console.log(this.introductionContentInfo);
      //   }
      // });
    },
    // handleScroll() {
    //   this.scroll =
    //     document.documentElement.scrollTop || document.body.scrollTop;
    //   if (
    //     this.scroll > this.getClientHeight * 2 &&
    //     this.scroll < this.getClientHeight * 3
    //   ) {
    //     this.matrixProdsHeight =
    //       30 - ((this.scroll - this.getClientHeight * 2) / this.scroll) * 300 >
    //       -20
    //         ? 30 -
    //           ((this.scroll - this.getClientHeight * 2) / this.scroll) * 300
    //         : -20;
    //     this.matrixProdsOpacity =
    //       ((this.scroll - this.getClientHeight * 2) / this.scroll) * 6 > 1
    //         ? 1
    //         : ((this.scroll - this.getClientHeight * 2) / this.scroll) * 6;
    //   }
    // }
  },

  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getShowImage();
    this.loadData();
  },

  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    setTimeout(() => {
      this.scrollin = true;
    }, 2500);

    const hash = window.location.hash;
    const index = hash.lastIndexOf("#");
    if (index != -1) {
      const id = hash.substring(index + 1, hash.length + 1);
      let y = 0;
      switch (id) {
        case "home":
          y = 0;
          break;
        case "introduction":
          y = this.getClientHeight;
          break;
        case "origin":
          y = this.getClientHeight * 2;
          break;
        case "products":
          y = this.getClientHeight * 3;
          break;
        case "techCenter":
          y = this.getClientHeight * 4;
          break;
        case "importExport":
          y = this.getClientHeight * 5;
          break;
        case "partner":
          y = this.getClientHeight * 6;
          break;
        case "aboutUs":
          y = this.getClientHeight * 7;
          break;

        default:
          break;
      }
      setTimeout(() => {
        window.scroll(0, y);
      }, 500);
    }

    window.addEventListener("scroll", this.handleScroll, false);
  },
};
</script>
<style lang='less' scoped>
.mIndex {
  background: #fff;
  font-size: 0.39rem;
  .khk_part_1 {
    position: relative;
    .khk_logo_img {
      position: absolute;
      top: 45%;
      left: 50%;
      display: flex;
      flex-direction: column;
      z-index: 11;
      transform: translate(-50%, -50%);
      width: 80%;
      img {
        width: 100%;
        height: 100%;
      }
      .khk_logo_img_2 {
        margin-top: 0.1rem;
        margin-bottom: 0.2rem;
        animation: pulse 1.5s ease-in-out 0.5s;
      }
      .scrollin {
        opacity: 0;
      }
      .scrollin.khk_logo_img_3 {
        transition: all 1s;
        opacity: 1;
      }
    }
    .swiper-container {
      .swiper-item {
        img {
          width: 100%;
          // height: 100%;
          vertical-align: top;
          object-fit: cover;
        }
      }
    }
    .search {
      position: absolute;
      bottom: 25%;
      left: 50%;
      display: flex;
      flex-direction: column;
      z-index: 11;
      transform: translate(-50%, -50%);
      width: 60%;
      input {
        background: rgba(255, 255, 255, 0);
        border: 1px solid #fff;
        height: 0.8rem;
        color: #fff;
        border-radius: 8px;
        padding-left: 0.2rem;
        font-size: 0.28rem;
        &::-webkit-input-placeholder {
          color: #fff;
        }
      }
      .key {
        position: absolute;
        right: 10px;
        top: 8px;
        width: 24px;
        cursor: pointer;
      }
    }
  }
  .khk_part_2 {
    background: url("../assets/m/H2/H2.png") no-repeat;
    background-size: 100% 100%;
    background-position: center center;
    // background-size: cover;
    .khk_part_2_content {
      position: relative;
      // width: 80%;
      // margin: 0 auto;
      // padding-top: 2.1rem;
      width: 84%;
      margin: 0 auto;
      padding: 25% 0% 5% 4%;
      img {
        width: 100%;
      }
    }
  }
  .khk_part_2_B {
    position: relative;
    background: url("../assets/m/H2B.jpg") no-repeat;
    background-size: cover;
    .khk_part_2_img {
      position: absolute;
      top: 45%;
      left: 50%;
      display: flex;
      flex-direction: column;
      z-index: 11;
      transform: translate(-50%, -50%);
      width: 90%;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .office {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      .swiper-container-two {
        .swiper-item {
          img {
            width: 100%;
            // height: 100%;
            vertical-align: top;
            object-fit: cover;
          }
        }
      }
    }
  }

  .khk_part_3 {
    background: url("../assets/m/H3/H3.png") no-repeat;
    background-size: 100% 100%;
    position: relative;
    .box_ul {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      padding-top: 30%;
      li {
        margin-bottom: 0.2rem;
        .prod {
          display: flex;
          justify-content: center;
          // &.prod1 {
          //   transform: matrix(1, 0, 0, 1, 0, 20);
          //   opacity: 0.12929;
          // }
          img {
            width: 50%;
            height: 100%;
          }
        }
      }
    }
    .khk_part_3_content {
      position: absolute;
      bottom: 0.4rem;
      left: 0;
      right: 0;
      .text_wrapper {
        position: relative;
        width: 100%;
        text-align: center;
        // color: red;
        color: #f82102;
        font-size: 12px;
        letter-spacing: 2px;
        font-weight: 600;
        p {
          margin: 6px;
        }
      }
    }
  }

  .khk_part_4 {
    background: url("../assets/m/h4.jpg") no-repeat;
    background-size: 100% 100%;
    .box_ul {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      padding-top: 25%;
      width: 4.91rem;
      margin: 0 auto;
      li {
        margin-bottom: 0.36rem;
        .tech {
          display: flex;
          justify-content: center;
          img {
            // width: 65%;
            // height: 100%;
            width: 2.05rem;
            height: 2.65rem;
          }
        }
      }
    }
    .tech-center {
      width: 5rem;
      height: 2.59rem;
      margin: 0 auto;

      // background: rgba(255, 255, 255, 0);
      // border-radius: 2px;
      // font-size: 24px;
      // font-weight: bold;
      // color: #003a7e;
      // line-height: 33px;
      > img {
        width: 100%;
      }
    }
  }

  // .khk_part_5 {
  //   background: url("../assets/m/h5.jpg") no-repeat;
  //   // background-size: 100% 100%;
  //   background-position: center center;
  //   background-size: cover;
  // }
  .khk_part_5 {
    position: relative;
    .khk_part_5_content {
      position: relative;
      width: 82%;
      margin: 0 auto;
      padding: 15% 0;
      img {
        width: 100%;
      }
    }
    .khk_part_5_btn_wrapper {
      position: absolute;
      bottom: 40px;
      left: 0px;
      .link_btn_area {
        // display: flex;
        // flex-flow: row nowrap;
        width: 80%;
        margin: 60px auto;

        display: flex;
        flex-flow: row nowrap;
        width: 100vw;
        justify-content: space-between;
        padding: 0 6vw;
        > a {
          text-align: center;
        }
        .img_btn {
          // animation: move 2s ease-out infinite;
          max-width: 200px;
          // height: 81px;
          width: 60%;
        }
      }
      .call_btn {
        position: fixed;
        bottom: 5px;
        left: 0;
        right: 10px;
        z-index: 999;
        // width: 100vw;
        // margin-top: 60px;
        // width: 70%;
        a {
          display: block;
          margin: 0 auto;
          width: 280px;
        }
        img {
          width: 100%;
        }
      }
      // .img_left {
      //   background: url("../assets/m/左按钮红.png") no-repeat 0 0;
      //   animation: move 2s ease-out infinite;
      //   @keyframes move {
      //     0% {
      //       // background-position: 0 0;
      //       background: url("../assets/m/左按钮蓝.png") no-repeat 0 0;
      //     }
      //     100% {
      //       background: url("../assets/m/左按钮红.png") no-repeat 0 0;
      //       // background-position: -200px 0;
      //     }
      //   }
      // }
      // .img_right {
      //   background: url("../assets/m/右按钮红.png") no-repeat 0 0;
      //   animation: move1 2s ease-out infinite;
      //   @keyframes move1 {
      //     0% {
      //       // background-position: 0 0;
      //       background: url("../assets/m/右按钮蓝.png") no-repeat 0 0;
      //     }
      //     100% {
      //       background: url("../assets/m/右按钮红.png") no-repeat 0 0;
      //       // background-position: -200px 0;
      //     }
      //   }
      // }
    }
  }

  .khk_part_6 {
    background: url("../assets/m/H6.jpg") no-repeat;
    background-size: cover;
    position: relative;

    .swiper-container-three {
      .swiper-item {
        img {
          width: 100%;
          // height: 100%;
          vertical-align: top;
          object-fit: cover;
        }
      }
    }
    .khk_info {
      font-size: 0.26rem;
      text-indent: 2em;
      margin-left: 30%;
      margin-top: 14%;
      padding: 0 0.3rem;
      p {
        line-height: 1.5;
        margin: 0;
        margin-bottom: 0.2rem;
      }
    }
    .btn {
      position: absolute;
      bottom: 0.5rem;
      left: 50%;
      text-align: center;
      // transform: translate(50%,50%);
      width: 40%;
      height: 0.84rem;
      background: #0583c9;
      line-height: 0.84rem;
      color: #fff;
      border-radius: 4px;
      margin-left: -20%;
      font-size: 0.36rem;
    }
  }
  .khk_part_7 {
    background: url("../assets/m/H7.jpg") no-repeat;
    background-size: cover;
    .about {
      display: flex;
      flex-direction: column;
      .pantner {
        text-align: center;
        img {
          width: 60%;
        }
      }
      .content {
        text-align: center;

        img {
          width: 60%;
        }
      }
    }
    .body_content {
      display: flex;
      margin-top: 0.53rem;
      margin-bottom: 0.24rem;
      justify-content: center;
      li {
        width: 18%;
        margin-right: 1%;
        &:last-child {
          margin-right: 0;
        }
        img {
          width: 100%;
        }
      }
    }
    .web-menu {
      display: flex;
      flex-flow: row nowrap;
      width: 100%;
      justify-content: center;
      .web-menu-item {
        padding: 0 12px;
        .web-menu-first {
          color: #247494;
          font-weight: 500;
          line-height: 18px;
          // font-size: 27px;
          font-size: 12px;
          text-align: left;
        }
        .web-menu-sub-item {
          .web-menu-sub {
            color: #0583c9;
            // font-size: 21px;
            font-size: 10px;
            line-height: 18px;
            cursor: pointer;
            &:hover {
              color: #b02125;
            }
            a {
              color: #0583c9;
            }
            a:hover {
              color: #b02125;
            }
          }
        }
      }
    }
  }

  @keyframes pulse {
    from {
      -webkit-transform: scale3d(1, 1, 1);
      transform: scale3d(1, 1, 1);
    }
    50% {
      -webkit-transform: scale3d(1.2, 1.2, 1.2);
      transform: scale3d(1.2, 1.2, 1.2);
    }
    to {
      -webkit-transform: scale3d(1, 1, 1);
      transform: scale3d(1, 1, 1);
      opacity: 1;
    }
  }

  @media only screen and (max-device-width: 736px) {
    .khk_part_5 {
      // position: relative;
      // margin: auto;
      // width: 100%;
      // height: 667px;
      // background: url("https://appleid.cdn-apple.com/static/bin/cb2713616020/dist/assets/apple_id_mobile.jpg") no-repeat;
      background: url("../assets//m/h750v6.png") no-repeat;
      background-size: 100% 100%;
      background-position: center center;
      // background-size: cover;
      // .img {
      //   height: 100px;
      //   position: absolute;
      //  bottom: 100px;
      // right: 50px;    }
    }
  }

  @media only screen and (min-width: 736px) {
    /*样式2*/
    .khk_part_5 {
      //  position: relative;
      // margin: auto;
      // width: 100%;
      // height: 1334px;
      // background: url("https://appleid.cdn-apple.com/static/bin/cb1555792862/dist/assets/apple_id_desktop_2880x1260.jpg") no-repeat;
      background: url("../assets/m/H5/H5.png") no-repeat;
      background-size: 100% 100%;
      background-position: center center;
      // background-size: cover;
      //  .img {
      //    height: 150px;
      //     position: absolute;
      //    bottom: 100px;
      //   right:100px ;
      //   }
    }
  }

  // @media only screen and (min-width: 750){
  //     /*样式2*/
  //    .khk_part_5 {
  //     width: 750px;

  //     background: url("../assets/m/h5.jpg") no-repeat;
  //     // background-size: 100% 100%;
  //     background-position: center center;
  //     background-size: cover;
  //   }
  // }
  .modal-backdrop {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.7);
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    z-index: 9999;
    .modal {
      background: #fff;
      height: 100%;
      position: relative;
      display: flex;
      flex-direction: column;
      .modal-close {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 10;
        padding: 0;
        width: 48px;
        height: 48px;
        text-align: center;
        line-height: 48px;
        color: rgba(0, 0, 0, 0.45);
        text-decoration: none;
        font-size: 18px;
        background: 0 0;
        border: 0;
        outline: 0;
        cursor: pointer;
        -webkit-transition: color 0.3s;
        transition: color 0.3s;
      }
      .modal-header {
        border-bottom: 1px solid #eee;
        color: #313131;
        justify-content: center;
        padding: 0.3rem 0.6rem;
        display: flex;
        font-size: 0.32rem;
      }
      .modal-body {
        height: 100%;
        font-size: 0.28rem;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>